import { Component } from '@angular/core';
import { IdentityStorage } from 'storage-service-lib';
import { ServiceProviderService } from '../../services/service.provider.service';

@Component({
    selector: 'app-bbar',
    template: `
    <div style="display: flex; justify-content: center; gap:1px;">
      @if (!error) {
        <!-- border: solid 1px green; -->
        @for (n of bars; track $index; let i = $index) {
          <span
            style="height: 1px; width: 3px; background-color: limegreen;"
            [ngStyle]="{ display: i < length ? 'block' : 'none' }"
          ></span>
        }
      } @else {
        <!-- border: solid 1px darkred; -->
        @for (n of bars; track $index; let i = $index) {
          <span
            style="height: 1px; width: 5px; background-color: red;"
            [ngStyle]="{ display: i < length ? 'block' : 'none' }"
          ></span>
        }
      }
    </div>
    `,
    standalone: false
})
export class BBarComponent {
  private static readonly MAX_LENGTH = 50;
  bars = new Array(BBarComponent.MAX_LENGTH);
  length = 0;
  error = false;

  constructor(serviceProviderService: ServiceProviderService, identityStorage: IdentityStorage) {
    const identity = identityStorage.get();
    if (!identity) {
      return;
    }
    serviceProviderService.getMetaDataService(identity.namespace).loadQueue$.subscribe(({ length, error }) => {
      this.length = length < BBarComponent.MAX_LENGTH ? length : BBarComponent.MAX_LENGTH;
      if (error) {
        this.error = error;
        // setTimeout(() => {this.length = 0}, 500);
      }
    });
  }
}
